<agingplan-article (getDisclosure)="getNetworkDisclosure($event)">
  <loading></loading>
</agingplan-article>
